import React, { useState } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import MediaViewerModal from './MediaViewerModal';
import { RenderIf } from '../RenderIf/RenderIf';
const MediaViewer = ({ allMedia, loadedPhotos, children, isShare = false, }) => {
    const mediaViewerModal = useDisclosure();
    const [currentItem, setCurrentItem] = useState(null);
    const handleMediaClick = (media) => {
        setCurrentItem(media);
        mediaViewerModal.onOpen();
    };
    const handleMediaKeyDown = (e, media) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            setCurrentItem(media);
            mediaViewerModal.onOpen();
        }
    };
    const handleOpenAtStart = () => {
        if (!allMedia?.length)
            return;
        setCurrentItem(allMedia[0]);
        mediaViewerModal.onOpen();
    };
    return (React.createElement(React.Fragment, null,
        children({
            onMediaClick: handleMediaClick,
            onMediaKeyDown: handleMediaKeyDown,
            onOpenAtStart: handleOpenAtStart,
        }),
        React.createElement(RenderIf, { condition: mediaViewerModal.isOpen && currentItem !== null },
            React.createElement(MediaViewerModal, { loadedPhotos: loadedPhotos, isOpen: mediaViewerModal.isOpen, onClose: mediaViewerModal.onClose, selectedItem: currentItem, allMedia: allMedia, isShare: isShare }))));
};
export default MediaViewer;
